export default __webpack_public_path__ + "static/media/logo5.51bddc87.png";